import { PettyWorkStatus } from "features/PettyWorks/constants/petty-work.constants";

function normalizeStatus(status: string | null | undefined): string {
  return String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
}

export function isTerminalPettyWorkForAssignment(
  status: string | null | undefined,
): boolean {
  const st = normalizeStatus(status);
  return (
    st === PettyWorkStatus.COMPLETED ||
    st === PettyWorkStatus.CANCELLED
  );
}

export function canReassignPettyWork(
  status: string | null | undefined,
): boolean {
  return !isTerminalPettyWorkForAssignment(status);
}

export function shouldShowPettyWorkAssignmentActions(
  status: string | null | undefined,
): boolean {
  return !isTerminalPettyWorkForAssignment(status);
}

/** No new material requests once the petty work is completed, cancelled, or rejected. */
export function pettyWorkAllowsMaterialRequest(
  status: string | null | undefined,
): boolean {
  return !isTerminalPettyWorkForAssignment(status);
}

/** Edit is only allowed while the petty work is not in a terminal state. */
export function canEditPettyWorkStatus(
  status: string | null | undefined,
): boolean {
  return !isTerminalPettyWorkForAssignment(status);
}
